export default "__VITE_ASSET__XxX3miqF__"